import { Link } from 'react-router-dom';
import { Mail, Globe, GraduationCap } from 'lucide-react';

const LOGO_URL = "/logo.png";
const LMS_URL = "https://lms.gihds.org";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#163A59]" data-testid="main-footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Institute Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 mb-6">
              <img 
                src={LOGO_URL} 
                alt="GIHDS Logo" 
                className="h-16 w-auto"
              />
            </div>
            <h3 className="font-['Source_Serif_4'] text-xl font-bold text-white mb-4">
              Geneva Institute of Humanitarian & Development Studies
            </h3>
            <p className="text-slate-300 leading-relaxed mb-6 max-w-md text-sm">
              Advancing humanitarian excellence through rigorous academic programs 
              designed for professionals committed to making a difference in the world.
            </p>
            <div className="flex flex-col gap-3 text-sm">
              <a href="mailto:admissions@gihds.org" className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors">
                <Mail size={18} />
                admissions@gihds.org
              </a>
              <a href="https://www.gihds.org" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors">
                <Globe size={18} />
                www.gihds.org
              </a>
              <a href={LMS_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors">
                <GraduationCap size={18} />
                Student Portal (LMS)
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-base text-white mb-6">Quick Links</h4>
            <nav className="flex flex-col gap-3 text-sm">
              <Link to="/about" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-about">
                About Us
              </Link>
              <Link to="/programs" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-program">
                Programs
              </Link>
              <Link to="/courses" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-courses">
                Courses
              </Link>
              <Link to="/scholarship" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-scholarship">
                Scholarship
              </Link>
              <Link to="/admissions" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-admissions">
                How to Apply
              </Link>
              <a href={LMS_URL} target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-lms">
                Student Portal (LMS)
              </a>
              <Link to="/faq" className="text-slate-300 hover:text-white transition-colors" data-testid="footer-faq">
                FAQ
              </Link>
            </nav>
          </div>

          {/* Program Info */}
          <div>
            <h4 className="font-semibold text-base text-white mb-6">Programs</h4>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/program/masters" className="text-slate-300 hover:text-white transition-colors">
                Master&apos;s - Humanitarian (1 Year)
              </Link>
              <Link to="/program/masters-ppm" className="text-slate-300 hover:text-white transition-colors">
                Master&apos;s - PPM (9 Months)
              </Link>
              <Link to="/program/doctoral" className="text-slate-300 hover:text-white transition-colors">
                Doctoral Program (3 Years)
              </Link>
              <p className="text-xs font-semibold text-slate-400 mt-3 uppercase tracking-wider">Short Courses</p>
              <Link to="/certificate/ai-humanitarian" className="text-slate-300 hover:text-white transition-colors">
                AI in Humanitarian Action & Development
              </Link>
              <p className="text-slate-300 mt-2">Mode: 100% Online</p>
              <div className="mt-4 pt-4 border-t border-slate-700">
                <p className="text-[#FCA5A5] font-semibold">90% Scholarship Available</p>
                <p className="text-xs mt-1 text-slate-300">For eligible Afro-Asia students</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-700">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {currentYear} Geneva Institute of Humanitarian & Development Studies. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/privacy-policy" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/refund-policy" className="text-slate-400 hover:text-white transition-colors">Refund Policy</Link>
              <Link to="/terms-of-service" className="text-slate-400 hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
